import React from "react";
import styles from "./ShopMegaMenuPromoBanner.module.scss";
import { Button } from "@swordsweeper/ssi-ui-component-library";

export interface ShopMegaMenuPromoBannerProps {
  onClaimOfferClick?: () => void;
}

export default function ShopMegaMenuPromoBanner(
  props: ShopMegaMenuPromoBannerProps,
) {
  const { onClaimOfferClick } = props;

  return (
    <div className={styles.banner}>
      <div className={styles.title}>
        New Practice Promotion — Up to 20% off your first order
      </div>
      <div className={styles.subtitle}>
        Exclusive pricing for practices joining getVetRx this month.
      </div>
      <Button
        id="shop-promo-claim-offer"
        className="btn btn-primary btn-sm"
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          onClaimOfferClick?.();
        }}
      >
        Claim Offer
      </Button>
    </div>
  );
}
